<template>
  <div>
    <div class="container">
      <div class="col-lg-12" style="padding: 0;">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterCompany"
        />
      </div>

      <div style="margin-top: 8px;">
        <b-table
          responsive
          show-empty
          hover
          :empty-text="$t('no_companies_were_found')"
          ref="table"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="companiesProvider"
          :fields="fields"
          @row-clicked="rowClicked"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              v-if="totalRows > 0"
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>

          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'CompanyOverview',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'company_overview',
      filter: this.getFilter(this, 'co-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'co-sortBy', 'companyName'),
      sortDesc: this.getSortDesc(this, 'co-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'co-currentPage', 1),
      perPage: this.getPerPage(this, 'co-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  methods: {
    filterCompany(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'co-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters);

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'co-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'co-currentPage', 1);
    },
    rowClicked(item, index, event) {
      this.$router.push({
        name: 'sales-group-overview',
        params: {
          id: item.companyId
        }
      });
    },
    companiesProvider(ctx) {
      var url = this.getServiceUr(
        'companies',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(
          ctx.sortBy,
          ctx.sortDesc,
          'company'
        )
      );

      this.setSortBy(this, 'co-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'co-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'co-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'co-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'co-perPage', this.perPage);
    },
    getDateFormatted: function(date) {
      return date === null || date === ''
        ? ''
        : this.$moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);

    this.$cookie.delete('sg-filter');
    this.$cookie.delete('sg-sortBy');
    this.$cookie.delete('sg-sortDesc');
    this.$cookie.delete('sg-currentPage');
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  return 10;
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'co-filter');

  const filterDefinition = [];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'companyName',
      label: context.$t('company'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left',
      class: 'tr-pointer'
    }
  ];
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>

<style scoped>
.row {
  cursor: pointer;
}
</style>
